import { api } from '../axios.helper';
import { Config, ProgrammeDto } from '@ecdlink/core';
import { ProgrammeInput, ProgrammeModelInput } from '@ecdlink/graphql';
class ProgrammeService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async updateProgrammes(
    programmeInput: ProgrammeModelInput
  ): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'UpdateProgrammes',
      variables: {
        programmeInput: programmeInput,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating programmes failed - Server connection error');
    }

    return true;
  }

  async updateProgramme(id: string, input: ProgrammeInput): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'UpdateProgramme',
      variables: {
        id: id,
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating programme failed - Server connection error');
    }

    return true;
  }

  async getUserProgrammes(): Promise<ProgrammeDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'userProgrammes',
    });

    if (response.status !== 200) {
      throw new Error('Get Programmes Failed - Server connection error');
    }

    return response.data.data.userProgrammes;
  }
}

export default ProgrammeService;
